"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function clearKnock(knock) {
  return (0, _utils.actionCreator)(_types.BROADCAST_CLEAR_KNOCK, knock);
}
var _default = exports["default"] = clearKnock;